import _concatInstanceProperty from '@babel/runtime-corejs3/core-js/instance/concat';
import { escape } from 'lodash-es';
import { prependPrefix } from '../utils/style.js';
import { DEFAULT_MARGIN, REMOVE_TOAST_DELAY, HIDE_TOAST_DELAY, DEFAULT_OFFSET_TOP } from './constants.js';

var wrapperClassName = prependPrefix('toast-wrapper'); // 指定 container 类名

var containerClassName = prependPrefix('toast-container'); // toast 文本区域类名

var toastClassName = prependPrefix('toast-text');
function toggleToast(msg, container) {
  var offsetTop = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OFFSET_TOP;
  var parent = document.body;

  if (typeof container === 'string') {
    parent = document.querySelector(container);
  } else if (container instanceof HTMLElement) {
    parent = container;
  }

  if (!parent) {
    return;
  } // 初始化 toastWrapper


  var toastWrapper = parent.querySelector(".".concat(wrapperClassName));

  if (!toastWrapper) {
    var _context;

    toastWrapper = document.createElement('span');
    toastWrapper.className = container ? _concatInstanceProperty(_context = "".concat(wrapperClassName, " ")).call(_context, containerClassName) : wrapperClassName;
    toastWrapper.setAttribute('style', "top: ".concat(offsetTop, "px"));
    parent.appendChild(toastWrapper);
  } // 创建 toast 文本区域


  var toast = document.createElement('span');
  toast.className = toastClassName;
  toast.style.top = "".concat(-DEFAULT_MARGIN, "px");
  toast.innerHTML = escape(msg);
  toastWrapper.appendChild(toast);
  var top = 0;
  var toasts = document.getElementsByClassName(toastClassName);

  for (var i = toasts.length - 1; i >= 0; i--) {
    var element = toasts[i];
    element.style.top = "".concat(top, "px");
    top += element.offsetHeight + DEFAULT_MARGIN;
  }

  toast.classList.add('show'); // 延时隐藏 toast

  setTimeout(function () {
    // 隐藏后延时移除 toast
    setTimeout(function () {
      var _parent, _toastWrapper, _toastWrapper2;

      var currentToastWrapper = (_parent = parent) === null || _parent === void 0 ? void 0 : _parent.querySelector(".".concat(wrapperClassName));
      (_toastWrapper = toastWrapper) === null || _toastWrapper === void 0 ? void 0 : _toastWrapper.removeChild(toast); // toast 队列为空后去除 toastWrapper

      if (!((_toastWrapper2 = toastWrapper) !== null && _toastWrapper2 !== void 0 && _toastWrapper2.getElementsByClassName(toastClassName).length) && currentToastWrapper) {
        var _parent2;

        (_parent2 = parent) === null || _parent2 === void 0 ? void 0 : _parent2.removeChild(currentToastWrapper);
      }
    }, REMOVE_TOAST_DELAY);
    toast.className = toastClassName;
  }, HIDE_TOAST_DELAY);
}

export { toggleToast };
